import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import Navbar from "../../components/Common/Navbar/Navbar";
import IntroSectionDevSecOps from '../../components/DevSecOps/IntroSectionDevSecOps/IntroSectionDevSecOps';
import IntroSectionDevSecOps2 from '../../components/DevSecOps/IntroSectionDevSecOps/IntroSectionDevSecOps2';
import IntroSectionDevSecOps3 from '../../components/DevSecOps/IntroSectionDevSecOps/IntroSectionDevSecOps3';
import ContactSection from '../../components/HomePage/ContactSectionHome/ContactSectionHome';
import ExpertiseSectionDevSecOps from '../../components/DevSecOps/ExpertiseSectionDevSecOps/ExpertiseSectionDevSecOps';
import ServicesCardsDevSecOps from '../../components/DevSecOps/ServicesCardsDevSecOps/ServicesCardsDevSecOps';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData1 from '../../components/Common/IntroSectionBottom/introSectionData1';
import './DevSecOps.css';
import useSectionRefs from '../../hooks/useSectionRefs';
import BenefitsPrivateCloud from '../../components/DevSecOps/ServicesSliderDevSecOps/BenefitsDevSecOps';
import ExpertiseSection from '../../components/CyberIncident/ExpertiseSectionCyberData/ExpertiseSectionCyberData';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import TimelinePrivateCloud from '../../components/DevSecOps/ServicesCardsDevSecOps/TimelinePrivateCloud';
import BenefitsDevSecOps from '../../components/DevSecOps/ServicesSliderDevSecOps/BenefitsDevSecOps';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import PricingSectionAzureDevSecOps from '../../components/ui/pricing-section-azure-devsecops';

const DevSecOps: React.FC = () => {
  const { t } = useTranslation();
  const sectionRefs = useSectionRefs();

  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header
            title={t('devSecOps.header.title', "DevSecOps & Sécurité")}
            mobileTitle={t('devSecOps.header.mobileTitle', "DevSecOps<br />& Sécurité")}
            subtitle={t('devSecOps.header.subtitle', "Intégrez la sécurité dans vos processus de développement")}
            mobileSubtitle={t('devSecOps.header.mobileSubtitle', "Intégrez la sécurité dans vos<br />processus de développement")}
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionDevSecOps />
      </section>

      <section id="commitment" className="section light" ref={sectionRefs.commitment}>
        <IntroSectionDevSecOps3 />
      </section>

      <section id="cloud" className="section dark" ref={sectionRefs.cloud}>
        <IntroSectionDevSecOps2 />
      </section>

      <div className="gradient-bg">
      <section id="start2" className="section light" ref={sectionRefs.start2}>
        <PricingSectionAzureDevSecOps />
      </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
        <TimelinePrivateCloud />
        <GridPatternCard>
          <GridPatternCardBody>
            <div className="tw-h-[5em]">
            </div>
          </GridPatternCardBody>
        </GridPatternCard>
          </section>
          </div>
      </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
        <ContactLinkSection pageKey="devSecOps" />
        <Footer />
      </section>
    </div>
    </div>
  );
};

export default DevSecOps;
